import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Login from './components/Login';
import LoadingScreen from './components/LoadingScreen';
import AccessibilityTools from './components/AccessibilityTools';

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      if (location.pathname === '/') {
        navigate('/home', { replace: true });
      }
    }, 900);

    return () => clearTimeout(timer);
  }, [location.pathname, navigate]);

  return (
    <div className="min-h-screen">
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <a
            href="#main-content"
            className="focus-ring fixed left-4 top-4 z-[70] -translate-y-20 rounded-xl bg-slate-950 px-4 py-3 text-sm font-semibold text-white shadow-xl transition focus:translate-y-0"
          >
            Skip to main content
          </a>
          <Navbar />
          <AccessibilityTools />
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </>
      )}
    </div>
  );
}

export default App;
